<template>
  <div class="nodePool">
    <div class="searchBox">
      <!-- <div class="searchLeft">
        <el-input
          size="medium"
          v-model="name"
          placeholder="请输入矿池名称"
        ></el-input>
        <el-button size="medium" type="primary" icon="el-icon-search">查询</el-button>
      </div> -->
      <div class="searchRight">
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addFunc">增加</el-button>
      </div>
    </div>
    <div class="table_box">
      <el-card class="box-card" v-for="(item,index) in tableData" :key="index">
        <div class="title_box">
          <div>矿池名称：{{item.name}}</div>
          <!-- <div><i class="el-icon-delete"></i></div> -->
        </div>
        <div class="node_box">
          <div class="node_n">矿池节点：</div>
          <div class="node_list"> {{getNode(item.nodeNumbers)}}
            <!-- <div v-for="(itm,indexs) in item.nodeNumbers" :key="indexs">{{itm}}</div> -->
          </div>
          
        </div>
        <div class="btn_box">
          <div class="btn_eidt" @click="setPool(item)">编辑节点</div>
          <div class="fiex1">
            <div class="btn_box_o" style="margin-right:10px">
              <div>自动分币</div>
              <el-switch
                @change="autoAllocateIsDel(item)"
                v-model="item.autoAllocate"
                active-color="#209e91"
                inactive-color="#999">
              </el-switch>
            </div>
            <div class="btn_box_o">
              <div>开启分币</div>
              <el-switch
                @change="ChangeTypeIsDel(item)"
                v-model="item.enable"
                active-color="#209e91"
                inactive-color="#999">
              </el-switch>
            </div>
          </div>
          
        </div>
      </el-card>
    </div>
    <div style="clear: both;"></div>
    <el-dialog
      :title="ruleForm.id?'编辑':'新增'"
      :visible.sync="dialogVisible"
      width="440px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="矿池名称" prop="name">
              <el-input placeholder="请输入矿池名称" v-model="ruleForm.name" style="width:240px"></el-input>
          </el-form-item>
          <el-form-item label="节点" prop="isDel">
            <el-select v-model="ruleForm.nodeNumbers" multiple placeholder="请选择" style="width:240px">
              <el-option
                v-for="item in dataArr"
                :key="item.key"
                :label="item.label"
                :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return{
      name: '',
      isSellCheck: true,
      dialogVisible: false,
      ruleForm: {},
      tableData: [],
      dataArr: [],
      rules: {
        name: [
          {required: true, message: '请输入矿池名称', trigger: 'blur' },
        ],
        nodeNumbers:[
          { required: true, message: '请选择节点', trigger: 'change' },
        ]
      },

    }
  },
  created(){
    this.nodeList()
    this.getTableList()
  },
  methods:{
    async autoAllocateIsDel(row){
      // let autoAllocate
      // console.log(row.autoAllocate)
      // if (row.autoAllocate) {
      //   autoAllocate = false
      // } else {
      //   autoAllocate = true
      // }
      // console.log(autoAllocate)
      let data = {
        autoAllocate: row.autoAllocate,
        id: row.id
      }
      let res = await this.$http.autoAllocate(data);
      if (res) {
        this.$message.success('操作成功！');
        this.getTableList()
      } 
    },
    submitForm(formName) {
      console.log(this.ruleForm)
      let _this = this
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let list = JSON.stringify(_this.ruleForm.nodeNumbers)
          let data
          let res
          if(this.ruleForm.id) {
            data = {
              id: _this.ruleForm.id,
              name: _this.ruleForm.name,
              nodeNumbers:list
            }
            res = await this.$http.nodePoolUpdate(data)
          } else {
            data = {
              name: _this.ruleForm.name,
              nodeNumbers:list
            }
            res = await this.$http.nodePoolAdd(data)
          }
          
          if (res) {
            this.$message.success('操作成功！');
            this.getTableList()
            this.dialogVisible=false
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 获取节点
    async nodeList() {
      let res = await this.$http.nodeALL()
      if (res)
      res.data.map((x)=>{
        this.dataArr.push({
          key: x.nodeNumber,
          label: x.nodeNumber
        })
      })
    },
    async getTableList(){
      let res = await this.$http.nodePoolAllDetail();
      if (res) {
        this.tableData=res.data
      }
    },
    setPool(item) {
      this.reset()
      let data = item
      this.ruleForm = {
        id: data.id,
        name: data.name,
        nodeNumbers: data.nodeNumbers
      }
      this.dialogVisible = true
    },
    addFunc(){
      this.reset()
      this.dialogVisible = true
    },
    async ChangeTypeIsDel(item) {
      let enable
      if (item.enable) {
        enable = true
      } else {
        enable = false
      }
      let data = {
        id: item.id,
        enable: enable
      }
      let res = await this.$http.nodePoolEnable(data);
      if (res) {
        this.$message.success('操作成功！');
        this.getTableList()
      }
      
    },
    getNode(val) {
      return val.join('、')
    },
    reset(){
      this.ruleForm = {
        id: null,
        name: null,
        nodeNumbers: null
      };
      this.resetForm("ruleForm");
    },
    resetForm(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    }
  }
}
</script>
<style scoped>
.nodePool{
  padding: 0px 0 20px;
}
.table_box{
  margin-top: 20px;
}
.box-card {
  width: 400px;
  height: 200px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
}
.box-card:nth-child(3n){
  margin-right: 0;
}
.title_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}
.node_box{
  display: flex;
  font-size: 14px;
}
.node_n{
  width: 70px;
  margin-right: 6px;
}
.node_list{
  width: 280px;
  height: 80px;
  line-height: 26px;
  position: relative;
  top: -3px;
  /* display: flex;
  align-items: center; */
}
/* .node_list */
.btn_box{
  height: 50px;
}
.btn_box,.btn_box_o{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.btn_eidt{
  padding: 4px 8px;
  background: #209e91;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}
.btn_box_o div:first-child{
  margin-right: 6px;
}
.fiex1{
  display: flex;
  align-items: center;
}
</style>